// touch - 2026-01-31 12:05
// Core namespaces
import commonCoreEn from '../locales/en/common/core.json';
import commonNavEn from '../locales/en/common/nav.json';
import commonMiscEn from '../locales/en/common/misc.json';
import commonCoreFr from '../locales/fr/common/core.json';
import commonNavFr from '../locales/fr/common/nav.json';
import commonMiscFr from '../locales/fr/common/misc.json';
import commonActionsEn from '../locales/en/common/actions.json';
import commonErrorsEn from '../locales/en/common/errors.json';
import commonFeedbackEn from '../locales/en/common/feedback.json';
import commonSuccessEn from '../locales/en/common/success.json';
import commonActionsFr from '../locales/fr/common/actions.json';
import commonErrorsFr from '../locales/fr/common/errors.json';
import commonFeedbackFr from '../locales/fr/common/feedback.json';
import commonSuccessFr from '../locales/fr/common/success.json';
import socialEn from '../locales/en/social.json';
import socialFr from '../locales/fr/social.json';
import levelsEn from '../locales/en/levels.json';
import levelsFr from '../locales/fr/levels.json';
import socialEs from '../locales/es/social.json';
import socialIt from '../locales/it/social.json';
import socialDe from '../locales/de/social.json';
import socialNl from '../locales/nl/social.json';
import socialPt from '../locales/pt/social.json';
import socialSv from '../locales/sv/social.json';

// Pro namespaces
import proManagementEn from '../locales/en/pro/management.json';
import proDashboardEn from '../locales/en/pro/dashboard.json';
import proPlanningEn from '../locales/en/pro/planning.json';
import proDomoticsEn from '../locales/en/pro/domotics.json';
import proSettingsEn from '../locales/en/pro/settings.json';
import proToolsEn from '../locales/en/pro/tools.json';
import proLayoutEn from '../locales/en/pro/layout.json';
import proMiscEn from '../locales/en/pro/misc.json';
import proCommonEn from '../locales/en/pro/common.json';
import proInventoryEn from '../locales/en/pro/inventory.json';
import proSubscriptionsEn from '../locales/en/pro/subscriptions.json';

import proManagementFr from '../locales/fr/pro/management.json';
import proDashboardFr from '../locales/fr/pro/dashboard.json';
import proPlanningFr from '../locales/fr/pro/planning.json';
import proDomoticsFr from '../locales/fr/pro/domotics.json';
import proSettingsFr from '../locales/fr/pro/settings.json';
import proToolsFr from '../locales/fr/pro/tools.json';
import proLayoutFr from '../locales/fr/pro/layout.json';
import proMiscFr from '../locales/fr/pro/misc.json';
import proCommonFr from '../locales/fr/pro/common.json';
import proInventoryFr from '../locales/fr/pro/inventory.json';
import proSubscriptionsFr from '../locales/fr/pro/subscriptions.json';

// Shared namespaces (mostly root-level)
import adminEn from '../locales/en/admin.json';
import adminFr from '../locales/fr/admin.json';
import authEn from '../locales/en/auth.json';
import authFr from '../locales/fr/auth.json';
import profileEn from '../locales/en/profile.json';
import profileFr from '../locales/fr/profile.json';
import matchesEn from '../locales/en/matches.json';
import matchesFr from '../locales/fr/matches.json';
import circlesEn from '../locales/en/circles.json';
import circlesFr from '../locales/fr/circles.json';
import feedEn from '../locales/en/feed.json';
import feedFr from '../locales/fr/feed.json';
import tournamentsEn from '../locales/en/tournaments.json';
import tournamentsFr from '../locales/fr/tournaments.json';
import onboardingEn from '../locales/en/onboarding.json';
import onboardingFr from '../locales/fr/onboarding.json';
import healthEn from '../locales/en/health.json';
import healthFr from '../locales/fr/health.json';
import marketplaceEn from '../locales/en/marketplace.json';
import marketplaceFr from '../locales/fr/marketplace.json';
import subscriptionsEn from '../locales/en/subscriptions.json';
import subscriptionsFr from '../locales/fr/subscriptions.json';
import subscriptionsEs from '../locales/es/subscriptions.json';
import subscriptionsIt from '../locales/it/subscriptions.json';
import subscriptionsDe from '../locales/de/subscriptions.json';
import subscriptionsNl from '../locales/nl/subscriptions.json';
import subscriptionsPt from '../locales/pt/subscriptions.json';
import subscriptionsSv from '../locales/sv/subscriptions.json';
import membershipsEn from '../locales/en/memberships.json';
import membershipsFr from '../locales/fr/memberships.json';
import membershipsEs from '../locales/es/memberships.json';
import membershipsIt from '../locales/it/memberships.json';
import membershipsDe from '../locales/de/memberships.json';
import membershipsNl from '../locales/nl/memberships.json';
import membershipsPt from '../locales/pt/memberships.json';
import membershipsSv from '../locales/sv/memberships.json';
import discoveryEn from '../locales/en/discovery.json';
import discoveryFr from '../locales/fr/discovery.json';
import discoveryEs from '../locales/es/discovery.json';
import discoveryIt from '../locales/it/discovery.json';
import discoveryDe from '../locales/de/discovery.json';
import discoveryNl from '../locales/nl/discovery.json';
import discoveryPt from '../locales/pt/discovery.json';
import discoverySv from '../locales/sv/discovery.json';
// import checkoutEn from '../locales/en/checkout.json';
// import checkoutFr from '../locales/fr/checkout.json';

import landingEn from '../locales/en/landing.json';
import clubsEn from '../locales/en/clubs.json';
import partnershipEn from '../locales/en/partnership.json';
import sharingEn from '../locales/en/sharing.json';
import iotEn from '../locales/en/iot.json';
import privacyEn from '../locales/en/privacy.json';
import cguEn from '../locales/en/cgu.json';
import publicEn from '../locales/en/public.json';
import playerEn from '../locales/en/player.json';
import mapEn from '../locales/en/map.json';
import installEn from '../locales/en/install.json';
import notificationsEn from '../locales/en/notifications.json';
import refereeEn from '../locales/en/referee.json';
import proTourEn from '../locales/en/pro_tour.json';

import landingFr from '../locales/fr/landing.json';
import clubsFr from '../locales/fr/clubs.json';
import partnershipFr from '../locales/fr/partnership.json';
import sharingFr from '../locales/fr/sharing.json';
import iotFr from '../locales/fr/iot.json';
import privacyFr from '../locales/fr/privacy.json';
import cguFr from '../locales/fr/cgu.json';
import publicFr from '../locales/fr/public.json';
import playerFr from '../locales/fr/player.json';
import mapFr from '../locales/fr/map.json';
import installFr from '../locales/fr/install.json';
import notificationsFr from '../locales/fr/notifications.json';
import refereeFr from '../locales/fr/referee.json';
import proTourFr from '../locales/fr/pro_tour.json';
import federationFr from '../locales/fr/federation.json';
import federationEn from '../locales/en/federation.json';

import solutionsEn from '../locales/en/solutions.json';
import solutionsFr from '../locales/fr/solutions.json';
import solutionsEs from '../locales/es/solutions.json';
import solutionsIt from '../locales/it/solutions.json';
import solutionsDe from '../locales/de/solutions.json';
import solutionsNl from '../locales/nl/solutions.json';
import solutionsPt from '../locales/pt/solutions.json';
import solutionsSv from '../locales/sv/solutions.json';

// Other languages (Shared namespaces only for now)
import commonCoreEs from '../locales/es/common/core.json';
import commonNavEs from '../locales/es/common/nav.json';
import commonMiscEs from '../locales/es/common/misc.json';
import commonActionsEs from '../locales/es/common/actions.json';
import commonErrorsEs from '../locales/es/common/errors.json';
import commonFeedbackEs from '../locales/es/common/feedback.json';
import commonSuccessEs from '../locales/es/common/success.json';
import landingEs from '../locales/es/landing.json';
import authEs from '../locales/es/auth.json';
import iotEs from '../locales/es/iot.json';
import mapEs from '../locales/es/map.json';
import partnershipEs from '../locales/es/partnership.json';
import profileEs from '../locales/es/profile.json';
import matchesEs from '../locales/es/matches.json';
import circlesEs from '../locales/es/circles.json';
import tournamentsEs from '../locales/es/tournaments.json';
import playerEs from '../locales/es/player.json';
import refereeEs from '../locales/es/referee.json';
import publicEs from '../locales/es/public.json';
import notificationsEs from '../locales/es/notifications.json';
import sharingEs from '../locales/es/sharing.json';
import feedEs from '../locales/es/feed.json';
import onboardingEs from '../locales/es/onboarding.json';
import healthEs from '../locales/es/health.json';
import marketplaceEs from '../locales/es/marketplace.json';
import clubsEs from '../locales/es/clubs.json';
import privacyEs from '../locales/es/privacy.json';
import cguEs from '../locales/es/cgu.json';
import installEs from '../locales/es/install.json';
import federationEs from '../locales/es/federation.json';
import levelsEs from '../locales/es/levels.json';

// Phase 4 - Spanish Pro & Admin
import proManagementEs from '../locales/es/pro/management.json';
import proDashboardEs from '../locales/es/pro/dashboard.json';
import proPlanningEs from '../locales/es/pro/planning.json';
import proDomoticsEs from '../locales/es/pro/domotics.json';
import proSettingsEs from '../locales/es/pro/settings.json';
import proToolsEs from '../locales/es/pro/tools.json';
import proLayoutEs from '../locales/es/pro/layout.json';
import proMiscEs from '../locales/es/pro/misc.json';
import proCommonEs from '../locales/es/pro/common.json';
import proInventoryEs from '../locales/es/pro/inventory.json';
import proSubscriptionsEs from '../locales/es/pro/subscriptions.json';
import proTourEs from '../locales/es/pro_tour.json';
import adminEs from '../locales/es/admin.json';

import commonCoreIt from '../locales/it/common/core.json';
import commonNavIt from '../locales/it/common/nav.json';
import commonMiscIt from '../locales/it/common/misc.json';
import commonActionsIt from '../locales/it/common/actions.json';
import commonErrorsIt from '../locales/it/common/errors.json';
import commonFeedbackIt from '../locales/it/common/feedback.json';
import commonSuccessIt from '../locales/it/common/success.json';
import landingIt from '../locales/it/landing.json';
import authIt from '../locales/it/auth.json';
import iotIt from '../locales/it/iot.json';
import mapIt from '../locales/it/map.json';
import partnershipIt from '../locales/it/partnership.json';
import matchesIt from '../locales/it/matches.json';
import profileIt from '../locales/it/profile.json';
import circlesIt from '../locales/it/circles.json';
import feedIt from '../locales/it/feed.json';
import tournamentsIt from '../locales/it/tournaments.json';
import playerIt from '../locales/it/player.json';
import refereeIt from '../locales/it/referee.json';
import publicIt from '../locales/it/public.json';
import notificationsIt from '../locales/it/notifications.json';
import sharingIt from '../locales/it/sharing.json';
import onboardingIt from '../locales/it/onboarding.json';
import healthIt from '../locales/it/health.json';
import marketplaceIt from '../locales/it/marketplace.json';
import clubsIt from '../locales/it/clubs.json';
import privacyIt from '../locales/it/privacy.json';
import cguIt from '../locales/it/cgu.json';
import installIt from '../locales/it/install.json';
import adminIt from '../locales/it/admin.json';
import federationIt from '../locales/it/federation.json';
import levelsIt from '../locales/it/levels.json';

// Pro namespaces IT
import proManagementIt from '../locales/it/pro/management.json';
import proDashboardIt from '../locales/it/pro/dashboard.json';
import proPlanningIt from '../locales/it/pro/planning.json';
import proDomoticsIt from '../locales/it/pro/domotics.json';
import proSettingsIt from '../locales/it/pro/settings.json';
import proToolsIt from '../locales/it/pro/tools.json';
import proLayoutIt from '../locales/it/pro/layout.json';
import proMiscIt from '../locales/it/pro/misc.json';
import proCommonIt from '../locales/it/pro/common.json';
import proInventoryIt from '../locales/it/pro/inventory.json';
import proSubscriptionsIt from '../locales/it/pro/subscriptions.json';
import proTourIt from '../locales/it/pro_tour.json';

import authDe from '../locales/de/auth.json';
import commonActionsDe from '../locales/de/common/actions.json';
import commonCoreDe from '../locales/de/common/core.json';
import commonErrorsDe from '../locales/de/common/errors.json';
import commonFeedbackDe from '../locales/de/common/feedback.json';
import commonMiscDe from '../locales/de/common/misc.json';
import commonNavDe from '../locales/de/common/nav.json';
import commonSuccessDe from '../locales/de/common/success.json';
import landingDe from '../locales/de/landing.json';
import iotDe from '../locales/de/iot.json';
import mapDe from '../locales/de/map.json';
import partnershipDe from '../locales/de/partnership.json';
import profileDe from '../locales/de/profile.json';
import matchesDe from '../locales/de/matches.json';
import feedDe from '../locales/de/feed.json';
import circlesDe from '../locales/de/circles.json';
import refereeDe from '../locales/de/referee.json';
import tournamentsDe from '../locales/de/tournaments.json';
import adminDe from '../locales/de/admin.json';
import marketplaceDe from '../locales/de/marketplace.json';
import onboardingDe from '../locales/de/onboarding.json';
import healthDe from '../locales/de/health.json';
import installDe from '../locales/de/install.json';
import notificationsDe from '../locales/de/notifications.json';
import sharingDe from '../locales/de/sharing.json';
import playerDe from '../locales/de/player.json';
import cguDe from '../locales/de/cgu.json';
import privacyDe from '../locales/de/privacy.json';
import publicDe from '../locales/de/public.json';
import clubsDe from '../locales/de/clubs.json';
import commonProDe from '../locales/de/pro/common.json';
import dashboardProDe from '../locales/de/pro/dashboard.json';
import domoticsProDe from '../locales/de/pro/domotics.json';
import inventoryProDe from '../locales/de/pro/inventory.json';
import layoutProDe from '../locales/de/pro/layout.json';
import managementProDe from '../locales/de/pro/management.json';
import miscProDe from '../locales/de/pro/misc.json';
import planningProDe from '../locales/de/pro/planning.json';
import settingsProDe from '../locales/de/pro/settings.json';
import toolsProDe from '../locales/de/pro/tools.json';
import proTourDe from '../locales/de/pro_tour.json';
import proSubscriptionsDe from '../locales/de/pro/subscriptions.json';
import federationDe from '../locales/de/federation.json';
import levelsDe from '../locales/de/levels.json';

import commonCoreNl from '../locales/nl/common/core.json';
import commonNavNl from '../locales/nl/common/nav.json';
import commonMiscNl from '../locales/nl/common/misc.json';
import commonActionsNl from '../locales/nl/common/actions.json';
import commonErrorsNl from '../locales/nl/common/errors.json';
import commonFeedbackNl from '../locales/nl/common/feedback.json';
import commonSuccessNl from '../locales/nl/common/success.json';
import landingNl from '../locales/nl/landing.json';
import iotNl from '../locales/nl/iot.json';
import mapNl from '../locales/nl/map.json';
import partnershipNl from '../locales/nl/partnership.json';
import authNl from '../locales/nl/auth.json';
import profileNl from '../locales/nl/profile.json';
import matchesNl from '../locales/nl/matches.json';
import feedNl from '../locales/nl/feed.json';
import circlesNl from '../locales/nl/circles.json';
import tournamentsNl from '../locales/nl/tournaments.json';
import refereeNl from '../locales/nl/referee.json';
import adminNl from '../locales/nl/admin.json';
import marketplaceNl from '../locales/nl/marketplace.json';
import onboardingNl from '../locales/nl/onboarding.json';
import healthNl from '../locales/nl/health.json';
import installNl from '../locales/nl/install.json';
import notificationsNl from '../locales/nl/notifications.json';
import sharingNl from '../locales/nl/sharing.json';
import playerNl from '../locales/nl/player.json';
import cguNl from '../locales/nl/cgu.json';
import privacyNl from '../locales/nl/privacy.json';
import publicNl from '../locales/nl/public.json';
import clubsNl from '../locales/nl/clubs.json';
import commonProNl from '../locales/nl/pro/common.json';
import dashboardProNl from '../locales/nl/pro/dashboard.json';
import layoutProNl from '../locales/nl/pro/layout.json';
import managementProNl from '../locales/nl/pro/management.json';
import planningProNl from '../locales/nl/pro/planning.json';
import toolsProNl from '../locales/nl/pro/tools.json';
import miscProNl from '../locales/nl/pro/misc.json';
import domoticsProNl from '../locales/nl/pro/domotics.json';
import inventoryProNl from '../locales/nl/pro/inventory.json';
import settingsProNl from '../locales/nl/pro/settings.json';
import proSubscriptionsNl from '../locales/nl/pro/subscriptions.json';
import federationNl from '../locales/nl/federation.json';
import levelsNl from '../locales/nl/levels.json';
import proTourNl from '../locales/nl/pro_tour.json';

import commonCorePt from '../locales/pt/common/core.json';
import commonNavPt from '../locales/pt/common/nav.json';
import commonMiscPt from '../locales/pt/common/misc.json';
import commonActionsPt from '../locales/pt/common/actions.json';
import commonErrorsPt from '../locales/pt/common/errors.json';
import commonFeedbackPt from '../locales/pt/common/feedback.json';
import commonSuccessPt from '../locales/pt/common/success.json';
import landingPt from '../locales/pt/landing.json';
import authPt from '../locales/pt/auth.json';
import iotPt from '../locales/pt/iot.json';
import mapPt from '../locales/pt/map.json';
import partnershipPt from '../locales/pt/partnership.json';
import profilePt from '../locales/pt/profile.json';
import matchesPt from '../locales/pt/matches.json';
import circlesPt from '../locales/pt/circles.json';
import feedPt from '../locales/pt/feed.json';
import tournamentsPt from '../locales/pt/tournaments.json';
import playerPt from '../locales/pt/player.json';
import refereePt from '../locales/pt/referee.json';
import publicPt from '../locales/pt/public.json';
import notificationsPt from '../locales/pt/notifications.json';
import sharingPt from '../locales/pt/sharing.json';
import onboardingPt from '../locales/pt/onboarding.json';
import healthPt from '../locales/pt/health.json';
import marketplacePt from '../locales/pt/marketplace.json';
import clubsPt from '../locales/pt/clubs.json';
import privacyPt from '../locales/pt/privacy.json';
import cguPt from '../locales/pt/cgu.json';
import installPt from '../locales/pt/install.json';
import adminPt from '../locales/pt/admin.json';
import federationPt from '../locales/pt/federation.json';
import levelsPt from '../locales/pt/levels.json';
import proTourPt from '../locales/pt/pro_tour.json';

import proManagementPt from '../locales/pt/pro/management.json';
import proDashboardPt from '../locales/pt/pro/dashboard.json';
import proPlanningPt from '../locales/pt/pro/planning.json';
import proDomoticsPt from '../locales/pt/pro/domotics.json';
import proSettingsPt from '../locales/pt/pro/settings.json';
import proToolsPt from '../locales/pt/pro/tools.json';
import proLayoutPt from '../locales/pt/pro/layout.json';
import proMiscPt from '../locales/pt/pro/misc.json';
import proCommonPt from '../locales/pt/pro/common.json';
import proInventoryPt from '../locales/pt/pro/inventory.json';
import proSubscriptionsPt from '../locales/pt/pro/subscriptions.json';

// Swedish (Modular)
import commonCoreSv from '../locales/sv/common/core.json';
import commonNavSv from '../locales/sv/common/nav.json';
import commonMiscSv from '../locales/sv/common/misc.json';
import commonActionsSv from '../locales/sv/common/actions.json';
import commonErrorsSv from '../locales/sv/common/errors.json';
import commonFeedbackSv from '../locales/sv/common/feedback.json';
import commonSuccessSv from '../locales/sv/common/success.json';

import proManagementSv from '../locales/sv/pro/management.json';
import proDashboardSv from '../locales/sv/pro/dashboard.json';
import proPlanningSv from '../locales/sv/pro/planning.json';
import proDomoticsSv from '../locales/sv/pro/domotics.json';
import proSettingsSv from '../locales/sv/pro/settings.json';
import proToolsSv from '../locales/sv/pro/tools.json';
import proLayoutSv from '../locales/sv/pro/layout.json';
import proMiscSv from '../locales/sv/pro/misc.json';
import proCommonSv from '../locales/sv/pro/common.json';
import proInventorySv from '../locales/sv/pro/inventory.json';
import proSubscriptionsSv from '../locales/sv/pro/subscriptions.json';
import proTourSv from '../locales/sv/pro_tour.json';

import adminSv from '../locales/sv/admin.json';
import authSv from '../locales/sv/auth.json';
import profileSv from '../locales/sv/profile.json';
import matchesSv from '../locales/sv/matches.json';
import circlesSv from '../locales/sv/circles.json';
import feedSv from '../locales/sv/feed.json';
import tournamentsSv from '../locales/sv/tournaments.json';
import onboardingSv from '../locales/sv/onboarding.json';
import healthSv from '../locales/sv/health.json';
import marketplaceSv from '../locales/sv/marketplace.json';
import landingSv from '../locales/sv/landing.json';
import clubsSv from '../locales/sv/clubs.json';
import partnershipSv from '../locales/sv/partnership.json';
import sharingSv from '../locales/sv/sharing.json';
import iotSv from '../locales/sv/iot.json';
import privacySv from '../locales/sv/privacy.json';
import cguSv from '../locales/sv/cgu.json';
import publicSv from '../locales/sv/public.json';
import playerSv from '../locales/sv/player.json';
import mapSv from '../locales/sv/map.json';
import installSv from '../locales/sv/install.json';
import notificationsSv from '../locales/sv/notifications.json';
import refereeSv from '../locales/sv/referee.json';
import federationSv from '../locales/sv/federation.json';
import levelsSv from '../locales/sv/levels.json';

/**
 * Deep merge utility for i18n shards.
 * Replaces shallow spreads to avoid key collisions.
 */
function deepMerge(...sources: any[]): any {
    const isObject = (item: any) => item && typeof item === 'object' && !Array.isArray(item);
    const target: any = {};

    sources.forEach(source => {
        if (!isObject(source)) return;
        Object.keys(source).forEach(key => {
            const targetValue = target[key];
            const sourceValue = source[key];

            if (isObject(targetValue) && isObject(sourceValue)) {
                target[key] = deepMerge(targetValue, sourceValue);
            } else {
                target[key] = sourceValue;
            }
        });
    });

    return target;
}

// Merge modular parts using deepMerge to prevent key collision overwrites
const commonEn = deepMerge(commonCoreEn, commonNavEn, commonMiscEn, commonActionsEn, commonErrorsEn, commonFeedbackEn, commonSuccessEn);
const commonFr = deepMerge(commonCoreFr, commonNavFr, commonMiscFr, commonActionsFr, commonErrorsFr, commonFeedbackFr, commonSuccessFr);
const commonEs = deepMerge(commonCoreEs, commonNavEs, commonMiscEs, commonActionsEs, commonErrorsEs, commonFeedbackEs, commonSuccessEs);
const proEn = deepMerge(proManagementEn, proDashboardEn, proPlanningEn, proDomoticsEn, proSettingsEn, proToolsEn, proLayoutEn, proMiscEn, proCommonEn, proInventoryEn, proSubscriptionsEn);
const proFr = deepMerge(proManagementFr, proDashboardFr, proPlanningFr, proDomoticsFr, proSettingsFr, proToolsFr, proLayoutFr, proMiscFr, proCommonFr, proInventoryFr, proSubscriptionsFr);
const proEs = deepMerge(proManagementEs, proDashboardEs, proPlanningEs, proDomoticsEs, proSettingsEs, proToolsEs, proLayoutEs, proMiscEs, proCommonEs, proInventoryEs, proSubscriptionsEs);
const commonIt = deepMerge(commonCoreIt, commonNavIt, commonMiscIt, commonActionsIt, commonErrorsIt, commonFeedbackIt, commonSuccessIt);
const commonNl = deepMerge(commonCoreNl, commonNavNl, commonMiscNl, commonActionsNl, commonErrorsNl, commonFeedbackNl, commonSuccessNl);
const commonPt = deepMerge(commonCorePt, commonNavPt, commonMiscPt, commonActionsPt, commonErrorsPt, commonFeedbackPt, commonSuccessPt);
const commonSv = deepMerge(commonCoreSv, commonNavSv, commonMiscSv, commonActionsSv, commonErrorsSv, commonFeedbackSv, commonSuccessSv);
const commonDe = deepMerge(commonCoreDe, commonNavDe, commonMiscDe, commonActionsDe, commonErrorsDe, commonFeedbackDe, commonSuccessDe);
const proIt = deepMerge(proManagementIt, proDashboardIt, proPlanningIt, proDomoticsIt, proSettingsIt, proToolsIt, proLayoutIt, proMiscIt, proCommonIt, proInventoryIt, proSubscriptionsIt);
const proPt = deepMerge(proManagementPt, proDashboardPt, proPlanningPt, proDomoticsPt, proSettingsPt, proToolsPt, proLayoutPt, proMiscPt, proCommonPt, proInventoryPt, proSubscriptionsPt);
const proSv = deepMerge(proManagementSv, proDashboardSv, proPlanningSv, proDomoticsSv, proSettingsSv, proToolsSv, proLayoutSv, proMiscSv, proCommonSv, proInventorySv, proSubscriptionsSv);
const proDe = deepMerge(commonProDe, dashboardProDe, domoticsProDe, inventoryProDe, layoutProDe, managementProDe, miscProDe, planningProDe, settingsProDe, toolsProDe, proSubscriptionsDe);
const proNl = deepMerge(commonProNl, dashboardProNl, layoutProNl, managementProNl, planningProNl, toolsProNl, miscProNl, domoticsProNl, inventoryProNl, settingsProNl, proSubscriptionsNl);

export const defaultNS = 'common';

export const resources = {
    en: {
        common: commonEn,
        pro: proEn,
        admin: adminEn,
        auth: authEn,
        profile: profileEn,
        matches: matchesEn,
        circles: circlesEn,
        feed: feedEn,
        tournaments: tournamentsEn,
        onboarding: onboardingEn,
        health: healthEn,
        marketplace: marketplaceEn,
        // checkout: checkoutEn,
        landing: landingEn,
        clubs: clubsEn,
        partnership: partnershipEn,
        sharing: sharingEn,
        iot: iotEn,
        privacy: privacyEn,
        cgu: cguEn,
        public: publicEn,
        player: playerEn,
        map: mapEn,
        install: installEn,
        notifications: notificationsEn,
        referee: refereeEn,
        discovery: discoveryEn,
        federation: federationEn,
        levels: levelsEn,
        pro_tour: proTourEn,
        social: socialEn,
        subscriptions: subscriptionsEn,
        memberships: membershipsEn,
        solutions: solutionsEn
    },
    fr: {
        common: commonFr,
        pro: proFr,
        admin: adminFr,
        auth: authFr,
        profile: profileFr,
        matches: matchesFr,
        circles: circlesFr,
        feed: feedFr,
        tournaments: tournamentsFr,
        onboarding: onboardingFr,
        health: healthFr,
        marketplace: marketplaceFr,
        // checkout: checkoutFr,
        landing: landingFr,
        clubs: clubsFr,
        partnership: partnershipFr,
        sharing: sharingFr,
        iot: iotFr,
        privacy: privacyFr,
        cgu: cguFr,
        public: publicFr,
        player: playerFr,
        map: mapFr,
        install: installFr,
        notifications: notificationsFr,
        referee: refereeFr,
        discovery: discoveryFr,
        federation: federationFr,
        levels: levelsFr,
        pro_tour: proTourFr,
        social: socialFr,
        subscriptions: subscriptionsFr,
        memberships: membershipsFr,
        solutions: solutionsFr
    },
    es: {
        common: commonEs,
        auth: authEs,
        landing: landingEs,
        profile: profileEs,
        matches: matchesEs,
        circles: circlesEs,
        tournaments: tournamentsEs,
        player: playerEs,
        referee: refereeEs,
        public: publicEs,
        notifications: notificationsEs,
        sharing: sharingEs,
        feed: feedEs,
        iot: iotEs,
        map: mapEs,
        partnership: partnershipEs,
        pro: proEs,
        admin: adminEs,
        onboarding: onboardingEs,
        health: healthEs,
        marketplace: marketplaceEs,
        clubs: clubsEs,
        privacy: privacyEs,
        cgu: cguEs,
        install: installEs,
        discovery: discoveryEs,
        federation: federationEs,
        levels: levelsEs,
        pro_tour: proTourEs,
        social: socialEs,
        subscriptions: subscriptionsEs,
        memberships: membershipsEs,
        solutions: solutionsEs
    },
    it: {
        common: commonIt,
        auth: authIt,
        landing: landingIt,
        iot: iotIt,
        map: mapIt,
        partnership: partnershipIt,
        matches: matchesIt,
        profile: profileIt,
        circles: circlesIt,
        feed: feedIt,
        tournaments: tournamentsIt,
        player: playerIt,
        referee: refereeIt,
        public: publicIt,
        notifications: notificationsIt,
        sharing: sharingIt,
        pro: proIt,
        admin: adminIt,
        onboarding: onboardingIt,
        health: healthIt,
        marketplace: marketplaceIt,
        clubs: clubsIt,
        privacy: privacyIt,
        cgu: cguIt,
        install: installIt,
        discovery: discoveryIt,
        federation: federationIt,
        levels: levelsIt,
        pro_tour: proTourIt,
        social: socialIt,
        subscriptions: subscriptionsIt,
        memberships: membershipsIt,
        solutions: solutionsIt
    },
    de: {
        common: commonDe,
        auth: authDe,
        landing: landingDe,
        iot: iotDe,
        map: mapDe,
        partnership: partnershipDe,
        profile: profileDe,
        matches: matchesDe,
        feed: feedDe,
        circles: circlesDe,
        referee: refereeDe,
        tournaments: tournamentsDe,
        admin: adminDe,
        marketplace: marketplaceDe,
        onboarding: onboardingDe,
        health: healthDe,
        install: installDe,
        notifications: notificationsDe,
        sharing: sharingDe,
        player: playerDe,
        cgu: cguDe,
        privacy: privacyDe,
        public: publicDe,
        clubs: clubsDe,
        pro: proDe,
        discovery: discoveryDe,
        federation: federationDe,
        levels: levelsDe,
        pro_tour: proTourDe,
        social: socialDe,
        subscriptions: subscriptionsDe,
        memberships: membershipsDe,
        solutions: solutionsDe
    },
    nl: {
        common: commonNl,
        landing: landingNl,
        iot: iotNl,
        map: mapNl,
        partnership: partnershipNl,
        auth: authNl,
        profile: profileNl,
        matches: matchesNl,
        feed: feedNl,
        circles: circlesNl,
        tournaments: tournamentsNl,
        referee: refereeNl,
        admin: adminNl,
        marketplace: marketplaceNl,
        onboarding: onboardingNl,
        health: healthNl,
        install: installNl,
        notifications: notificationsNl,
        sharing: sharingNl,
        player: playerNl,
        cgu: cguNl,
        privacy: privacyNl,
        public: publicNl,
        clubs: clubsNl,
        pro: proNl,
        discovery: discoveryNl,
        federation: federationNl,
        levels: levelsNl,
        pro_tour: proTourNl,
        social: socialNl,
        subscriptions: subscriptionsNl,
        memberships: membershipsNl,
        solutions: solutionsNl
    },
    pt: {
        common: commonPt,
        landing: landingPt,
        iot: iotPt,
        map: mapPt,
        partnership: partnershipPt,
        auth: authPt,
        profile: profilePt,
        matches: matchesPt,
        circles: circlesPt,
        feed: feedPt,
        tournaments: tournamentsPt,
        player: playerPt,
        referee: refereePt,
        public: publicPt,
        notifications: notificationsPt,
        sharing: sharingPt,
        pro: proPt,
        admin: adminPt,
        onboarding: onboardingPt,
        health: healthPt,
        marketplace: marketplacePt,
        clubs: clubsPt,
        privacy: privacyPt,
        cgu: cguPt,
        install: installPt,
        discovery: discoveryPt,
        federation: federationPt,
        levels: levelsPt,
        pro_tour: proTourPt,
        social: socialPt,
        subscriptions: subscriptionsPt,
        memberships: membershipsPt,
        solutions: solutionsPt
    },
    sv: {
        common: commonSv,
        pro: proSv,
        admin: adminSv,
        auth: authSv,
        profile: profileSv,
        matches: matchesSv,
        circles: circlesSv,
        feed: feedSv,
        tournaments: tournamentsSv,
        onboarding: onboardingSv,
        health: healthSv,
        marketplace: marketplaceSv,
        landing: landingSv,
        clubs: clubsSv,
        partnership: partnershipSv,
        sharing: sharingSv,
        iot: iotSv,
        privacy: privacySv,
        cgu: cguSv,
        public: publicSv,
        player: playerSv,
        map: mapSv,
        install: installSv,
        notifications: notificationsSv,
        referee: refereeSv,
        discovery: discoverySv,
        federation: federationSv,
        levels: levelsSv,
        pro_tour: proTourSv,
        social: socialSv,
        subscriptions: subscriptionsSv,
        memberships: membershipsSv,
        solutions: solutionsSv
    }
} as any;
